<template>
  <ControlWrapper
    v-bind="control.controlWrapper.value"
    :styles="control.styles"
    :is-focused="control.isFocused.value"
    :applied-options="control.appliedOptions.value"
  >
    <section id="widget-welcome" class="widget-welcome-step">
      <div class="widget-welcome-step_wrapper">
        <div class="default-gap flex w-full flex-col">
          <div class="widget-welcome-step_header">
            <h2 class="widget-welcome-step_header--title" :class="componentStyles?.title || ''">
              {{ settings.title }}
            </h2>
            <p class="widget-welcome-step_header--description">
              {{ settings.subtitle }}
            </p>
          </div>
          <ContactInfoCard
            v-if="settings?.callUs?.text"
            :phone="{
              number: config.contact.phone,
              title: settings.callUs.text,
            }"
          />
          <div v-if="settings.title2 || settings?.subtitle2" class="widget-welcome-step_header">
            <h2 v-if="settings.title2" class="widget-welcome-step_header--title">{{ settings.title2 }}</h2>
            <p v-if="settings?.subtitle2" class="widget-welcome-step_header--description">
              {{ settings.subtitle2 }}
            </p>
          </div>
          <div v-if="progressList?.length" class="widget-welcome-step_body">
            <div class="widget-welcome-step_body--child" v-for="(item, index) in progressList" :key="index">
              <div class="relative flex h-full flex-col items-center justify-between">
                <WidgetIcon
                  :icon="item.checked ? `${themeIcons.checkCircle}` : `${themeIcons.circle}`"
                  width="1.8125rem"
                  class="widget-welcome-step_body--list-item"
                />
                <div
                  v-if="index !== progressList.length - 1 && checkTheme('default')"
                  class="widget-welcome-step_body--checklist-line"
                ></div>
              </div>
              <span class="widget-welcome-step_body--text">{{ item.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ControlWrapper>
</template>

<script setup lang="ts">
  import { ControlElement } from '@jsonforms/core';
  import { rendererProps, useJsonFormsControl } from '@jsonforms/vue';
  import { default as ControlWrapper } from './ControlWrapper.vue';
  import { useWidgetControl } from '../util';
  import { nextTick, ref } from 'vue';
  import { config, themeIcons, checkTheme, getComponentStyle } from 'src/utils/config';
  import { Ref, inject, onMounted } from 'vue';
  import WidgetIcon from '../../base/WidgetIcon.vue';
  import ContactInfoCard from 'src/components/claims-widget/components/ContactInfoCard.vue';

  export type WelcomeStepConfig = {
    title: string;
    title2?: string;
    paragraphs?: { text: string; checked: boolean }[];
    callUs?: { text?: string };
    action: string;
    icon: string;
    subtitle: string;
    subtitle2?: string;
    roadWorthy: { text: string; icon?: string };
    hours?: { title: string; integration: string };
  };

  const props = defineProps(rendererProps<ControlElement>());
  const control = useWidgetControl(useJsonFormsControl(props));
  const settings = ref((control.control.value.schema as unknown as { welcomeStep: WelcomeStepConfig }).welcomeStep);
  const rootElement = inject<Ref<HTMLDivElement>>(config.value.rootKey);
  settings.value.subtitle = settings.value.subtitle?.replaceAll('#clientname', config.value.name);
  const progressList = settings.value.paragraphs;

  onMounted(() => {
    nextTick(() => {
      rootElement?.value.scrollTo(0, 0);
      document.scrollingElement?.scrollTo(0, 0);
      window.scrollTo(0, 0);
    });
  });

  const componentStyles = getComponentStyle();
</script>

<style scoped></style>
